import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { SYSTEM_DATE_FORMAT, DATE_FORMAT_LONG } from 'CorePackage/MainModule/constants/dateFormat';

import { IKnmSearchInitFilter } from '../interfaces/IKnmSearchInitFilter';
import { ISearchFilterData } from '../interfaces/ISearchFilterData';

export const getSearchFilterData = (value: Partial<IKnmSearchInitFilter>): Partial<ISearchFilterData> => {
  const newValue = {
    frguOrgName: value && value.frguOrgName ? value.frguOrgName : '',
    prosecutorName: value && value.prosecutorName ? value.prosecutorName : '',
    subjectType: value && value.subjectType ? value.subjectType.map(item => item.value) : [],
    knmType: value && value.knmType ? value.knmType.map(item => item.value) : [],
    year: value && value.year ? value.year.map(item => item.value) : [],
    supervisionName: value && value.supervisionName ? value.supervisionName.value : '',
    organizationName: value && value.organizationName ? value.organizationName : '',
    erpId: value && value.erpId ? value.erpId : '',
    inn: value && value.inn ? value.inn : '',
    ogrn: value && value.ogrn ? value.ogrn : '',
    status: value && value.status ? value.status.map(item => item.value) : [],
    startMonth: value && value.startMonth ? value.startMonth.map(item => item.value) : [],
    fromDate:
      value && value.fromDate
        ? formatDate({ date: value.fromDate, dateFormat: SYSTEM_DATE_FORMAT, parseFormat: DATE_FORMAT_LONG })
        : '',
    toDate:
      value && value.toDate
        ? formatDate({ date: value.toDate, dateFormat: SYSTEM_DATE_FORMAT, parseFormat: DATE_FORMAT_LONG })
        : '',
    federalLaws: value && value.federalLaws ? value.federalLaws.map(item => item.value) : [],
  };
  return newValue;
};
